import React, { useState } from "react";
import { Modal, Button } from "../../../components/ui";
import { FormField, Input, Textarea } from "../../../components/ui/FormComponents";
import { Truck, User, Hash } from "lucide-react";

export const DispatchModal = ({ isOpen, onClose, onConfirm, requestId }) => {
  const [driverName, setDriverName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!driverName || !vehicleNo) return;
    onConfirm(requestId, {
      status: "dispatched",
      dispatchDetails: {
        driverName,
        vehicleNumber: vehicleNo,
        notes: description,
      }
    });
    setDriverName("");
    setVehicleNo("");
    setDescription("");
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="Dispatch Materials" 
      size="sm"
      footer={
        <div className="flex flex-col-reverse sm:flex-row items-center gap-3 w-full">
          <Button 
            type="button" 
            variant="secondary" 
            className="w-full sm:flex-1 h-10 rounded-lg text-[12px] font-bold" 
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button 
            variant="orange" 
            onClick={handleSubmit}
            className="w-full sm:flex-1 h-10 rounded-lg text-[12px] font-bold"
          >
            Confirm Dispatch
          </Button>
        </div>
      }
    >
      <div className="space-y-5 font-poppins">
        <div className="bg-brand-orange/5 p-4 rounded-xl border border-brand-orange/10 flex items-center gap-3">
          <div className="w-10 h-10 bg-brand-orange/10 rounded-full flex items-center justify-center text-brand-orange">
            <Truck size={20} />
          </div>
          <div>
            <h4 className="text-sm font-bold text-slate-800">Assign Delivery Details</h4>
            <p className="text-[10px] text-slate-500 uppercase font-black tracking-widest">Request: {requestId}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <FormField label="Driver Name" required>
            <div className="relative">
              <Input
                placeholder="Driver full name"
                value={driverName}
                onChange={(e) => setDriverName(e.target.value)}
                className="pl-9"
              />
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            </div>
          </FormField>

          <FormField label="Vehicle Number" required>
            <div className="relative">
              <Input
                placeholder="AB-12-CD-3456"
                value={vehicleNo}
                onChange={(e) => setVehicleNo(e.target.value)}
                className="pl-9 uppercase font-bold tracking-wider"
              />
              <Hash className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            </div>
          </FormField>
        </div>

        <FormField label="Description / Notes (Optional)">
          <Textarea
            placeholder="Add any additional delivery instructions or notes..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
          />
        </FormField>
      </div>
    </Modal>
  );
};

